import React, {useEffect} from "react";
import {Grid} from "@material-ui/core";
import styled from "styled-components";
import blankProfile from "../../../img/blank-profile.png";
import blankLogo from "../../../img/blank-logo.png";
import {AuthMeModel} from "../../../models/auth-me.model";
import {RootState} from "../../../store/root-reducer";
import {useSelector} from "react-redux";
import {AccountTypeEnum} from "../../../models/account-type.enum";
import {CustomEditIcon} from "../../ui-base/icons/custom-edit-icon";
import {Colors} from "../../../theme/colors";
import {useTranslation} from "react-i18next";

export const EditProfileAvatar = ({initialImage, handleImage}) => {
    const [image, setImage] = React.useState(blankProfile);
    const authMe: AuthMeModel = useSelector(
        (state: RootState) => state.auth.user
    );
    const { t } = useTranslation('author');

    useEffect(() => {
        if (!initialImage && authMe && authMe.account_type === AccountTypeEnum.AUT) {
            setImage(blankProfile);
        }

        if (!initialImage && authMe && authMe.account_type === AccountTypeEnum.PUB) {
            setImage(blankLogo);
        }

        if (initialImage) {
            setImage(initialImage);
        }
    }, [authMe, initialImage]);

    return (
        <Grid
            container
            direction="row"
            style={{marginBottom: '1rem'}}
        >
            <div
                style={{position: 'relative'}}
            >
                <StyledImg src={image} alt="avatar"/>

                <StyledLabelUpload htmlFor="file">
                    <Grid container direction={"row"} style={{marginLeft: '20px'}}>
                        <Grid item>
                            <CustomEditIcon style={{fill: Colors.lightViolet, fontSize: '0.8rem', cursor: 'pointer'}}/>
                        </Grid>
                        <Grid item>
                            <StyledEditAvatarP>{t('editProfileAvatar.editPicture')}</StyledEditAvatarP>
                        </Grid>
                    </Grid>
                </StyledLabelUpload>
                <StyledUploadInput
                    id={'file'}
                    name={'file'}
                    onChange={(event) => {
                        const reader = new FileReader();

                        reader.onload = (e) => {
                            setImage(e.target.result as string);
                        }

                        reader.readAsDataURL(event.target.files[0]);
                        handleImage(event.target.files);
                    }}
                    type="file"
                />
            </div>
        </Grid>
    )
}

const StyledImg = styled('img')`
  max-height: 150px;
  max-width: 100%;
`;

const StyledLabelUpload = styled('label')`
  
`;

const StyledEditAvatarP = styled('p')`
  font-weight: 500;
  color: ${Colors.lightViolet};
  margin-left: 2px;
  cursor: pointer;
`;

const StyledUploadInput = styled('input')`
    height: 0;
    width:1px
`;
